import { Badge } from "@/components/ui/badge";
import { Button } from "@/components/ui/button";
import { DropdownMenu, DropdownMenuContent, DropdownMenuItem, DropdownMenuTrigger } from "@/components/ui/dropdown-menu";
import { Tooltip, TooltipContent, TooltipProvider, TooltipTrigger } from "@/components/ui/tooltip";
import { AlertTriangle, Package } from "lucide-react";

interface PackDiscrepancyChipProps {
  invoicePack: number | null;
  receivedPack: number | null;
  onUseInvoicePack?: () => void;
  onUseReceivedPack?: () => void;
  onEditPack?: () => void;
  className?: string;
}

export function PackDiscrepancyChip({
  invoicePack,
  receivedPack,
  onUseInvoicePack,
  onUseReceivedPack,
  onEditPack,
  className
}: PackDiscrepancyChipProps) {
  const hasDiscrepancy = invoicePack && receivedPack && invoicePack !== receivedPack;
  const displayPack = invoicePack || receivedPack;

  if (!displayPack) {
    return (
      <Badge variant="outline" className={className}>
        <Package className="w-3 h-3 mr-1" />
        No Pack
      </Badge>
    );
  }

  if (!hasDiscrepancy) {
    return (
      <Badge variant="outline" className={className}>
        <Package className="w-3 h-3 mr-1" />
        {displayPack}/ct
      </Badge>
    );
  }

  return (
    <TooltipProvider>
      <Tooltip>
        <TooltipTrigger asChild>
          <DropdownMenu>
            <DropdownMenuTrigger asChild>
              <Badge variant="destructive" className={`cursor-pointer ${className}`}>
                <AlertTriangle className="w-3 h-3 mr-1" />
                {displayPack}/ct
              </Badge>
            </DropdownMenuTrigger>
            <DropdownMenuContent align="start">
              {invoicePack && onUseInvoicePack && (
                <DropdownMenuItem onClick={onUseInvoicePack}>
                  Use invoice pack ({invoicePack}/ct)
                </DropdownMenuItem>
              )}
              {receivedPack && onUseReceivedPack && (
                <DropdownMenuItem onClick={onUseReceivedPack}>
                  Use received pack ({receivedPack}/ct)
                </DropdownMenuItem>
              )}
              {onEditPack && (
                <DropdownMenuItem onClick={onEditPack}>
                  Enter custom pack...
                </DropdownMenuItem>
              )}
            </DropdownMenuContent>
          </DropdownMenu>
        </TooltipTrigger>
        <TooltipContent>
          <div className="space-y-1">
            <p className="font-medium">Pack Size Discrepancy</p>
            <p className="text-xs">Invoice: {invoicePack}/ct</p>
            <p className="text-xs">Received: {receivedPack}/ct</p>
            <p className="text-xs text-muted-foreground">Click to resolve</p>
          </div>
        </TooltipContent>
      </Tooltip>
    </TooltipProvider>
  );
}